/**
 * « Mes informations » (SPEC MC1, MC7 ; retour M6) — maquette 17-compte (`.kv` + « Modifier mes
 * informations »). Données = UserProfile.tsx Profile() (GET client/me : adresse, téléphone, e-mail, pointure).
 *
 * Retours de Daphné du 12/10 : « Modifier mon mot de passe » n'a pas besoin d'être un bouton aussi visible sur la
 * page principale ; il est dans « Modifier mes informations » (route account/edit, components/PasswordChange.tsx).
 */
import { useFetchMe } from 'hooks/useApiQueries';
import { useNavigate } from 'react-router';

export function InformationsCard() {
  const navigate = useNavigate();
  const { data: user, isLoading } = useFetchMe();
  const shoeSize = user?.CustomClientFields?.find((f) => f.Name === 'Shoe size')?.Value;
  const address = [user?.AddressLine1, user?.AddressLine2, [user?.PostalCode, user?.City].filter(Boolean).join(' ')]
    .map((line) => (typeof line === 'string' ? line.trim() : ''))
    .filter(Boolean);

  return (
    <section className="mmv2-card mmv2-card--pad mmv2-acct-side" aria-labelledby="mmv2-acct-infos">
      <h2 className="mmv2-acct-kicker" id="mmv2-acct-infos">
        Mes informations
      </h2>
      {isLoading ? (
        <div className="mmv2-acct-skeleton mmv2-acct-skeleton--line" aria-busy="true" aria-label="Chargement" />
      ) : (
        <dl className="mmv2-acct-kv">
          <div>
            <dt>E-mail</dt>
            <dd>{user?.Email || '—'}</dd>
          </div>
          <div>
            <dt>Téléphone</dt>
            <dd>{user?.MobilePhone || '—'}</dd>
          </div>
          <div>
            <dt>Adresse</dt>
            <dd>
              {address.length
                ? address.map((line, i) => (
                    <span key={i} className="mmv2-acct-kv__line">
                      {line}
                    </span>
                  ))
                : '—'}
            </dd>
          </div>
          {shoeSize ? (
            <div>
              <dt>Pointure</dt>
              <dd>{shoeSize}</dd>
            </div>
          ) : null}
        </dl>
      )}
      <div className="mmv2-acct-side__buttons">
        <button
          type="button"
          className="mmv2-btn mmv2-btn--ghost mmv2-btn--sm mmv2-btn--block"
          onClick={() => navigate('edit')}
        >
          Modifier mes informations
        </button>
      </div>
    </section>
  );
}
